import { render, staticRenderFns } from "./CaseFieldDisplay.vue?vue&type=template&id=37574935&scoped=true&"
import script from "./CaseFieldDisplay.vue?vue&type=script&lang=ts&"
export * from "./CaseFieldDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFieldDisplay.vue?vue&type=style&index=0&id=37574935&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37574935",
  null
  
)

export default component.exports